export const environment = {
  production: true,
  //api: "https://mosadottest.heseim.co.il/api/",//test
   api: "https://mosadot.heseim.co.il/api/",//prod


  routes: {
    login: { url: 'login' },

  },
  password: "Test12!"
};


